<template>
    <div>
        <div ref="editor" style="text-align:left"></div>
    </div>
</template>

<script>
    import E from 'wangeditor';

    export default {
      name: 'Editor',
      props: {
        value: {
          type: String,
          default(){
            return '';
          }
        }
      },
      data () {
        return {
          editor: null
        };
      },
      methods: {

      },
      mounted() {
        this.editor = new E(this.$refs.editor);
        this.editor.customConfig.onchange = (html) => {
          this.$emit('input', html);
        };
        this.editor.customConfig.uploadImgShowBase64 = true; //使用base64保存图片
        // 将图片大小限制为 3M
        this.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
        this.editor.customConfig.uploadFileName = 'file';
        // 限制一次最多上传 1 张图片
        this.editor.customConfig.uploadImgMaxLength = 1;

        this.editor.create();
        this.editor.txt.html(this.value);
      }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Editor.vue?253e2838